export enum RightButtonType {
  Gift = 'gift',
  Alarm = 'alarm',
  Continue = 'continue',
  NextProduct = 'nextProduct',
}
